const MobileSVG = ({ fill, stroke }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Group 29">
        <rect
          id="Rectangle 78"
          x="1.83398"
          y="2.16699"
          width="16.3333"
          height="25.6667"
          rx="2"
          stroke={stroke}
          stroke-width="2.5"
        />
        <circle id="Ellipse 48" cx="10" cy="23.167" r="1.75" fill={fill} />
      </g>
    </svg>
  );
};

export default MobileSVG;
